





















import Vue from 'vue'
import { REPORT_URL_BASE } from '@/constants/urls'
import { KC } from '@/http/utils'
import { timeout } from '@/utils/time'

type Props = {
  pdfReport: string | null
  showWaiting: boolean
  statusText: string
}

export default Vue.extend({
  data(): Props {
    return {
      pdfReport: null,
      showWaiting: true,
      statusText: 'Generating patient report...',
    }
  },
  async mounted(): Promise<void> {
    const reportUrl = [REPORT_URL_BASE, this.$route.params.patient_id, this.$route.params.timestamp].join('/')
    await this.initComponent({ reportUrl, path: this.$route.path })
  },
  async beforeRouteUpdate(to, from, next): Promise<void> {
    const reportUrl = [REPORT_URL_BASE, to.params.patient_id, to.params.timestamp].join('/')
    await this.initComponent({ reportUrl, path: to.path })
    next()
  },
  methods: {
    async initComponent({ reportUrl, path }): Promise<void> {
      this.pdfReport = null
      this.showWaiting = true
      await this.getPdfReport(reportUrl)
      if (!this.pdfReport) {
        await this.$router.replace({ name: '404', params: { '0': path } })
        return
      }
      this.showWaiting = false
    },
    async getPdfReport(reportUrl): Promise<void> {
      const config = await KC.getPdfFetchConfig()
      const res = await fetch(reportUrl, config)

      if (res.status === 200) {
        const data = await res.blob()
        const newBlob = new Blob([data], { type: 'application/pdf' })
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob)
        } else {
          const blobUrl = window.URL.createObjectURL(newBlob)
          this.pdfReport = blobUrl
        }
      } else {
        await timeout(200)
        this.pdfReport = null
      }
    },
  },
})
